/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  ExportCertificatesPdfMutationRequest,
  ExportCertificatesPdfMutationResponse,
} from "../types/ExportCertificatesPdf.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const exportCertificatesPdfMutationKey = () =>
  [{ url: "/v1/certificate/export-certificates-pdf" }] as const

export type ExportCertificatesPdfMutationKey = ReturnType<
  typeof exportCertificatesPdfMutationKey
>

/**
 * @summary Export certificates pdf
 * {@link /v1/certificate/export-certificates-pdf}
 */
export async function exportCertificatesPdf(
  data: ExportCertificatesPdfMutationRequest,
  config: Partial<RequestConfig<ExportCertificatesPdfMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportCertificatesPdfMutationResponse,
    ResponseErrorConfig<Error>,
    ExportCertificatesPdfMutationRequest
  >({
    method: "POST",
    url: `/v1/certificate/export-certificates-pdf`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function exportCertificatesPdfMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<ExportCertificatesPdfMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = exportCertificatesPdfMutationKey()
  return mutationOptions<
    ResponseConfig<ExportCertificatesPdfMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ExportCertificatesPdfMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return exportCertificatesPdf(data, config)
    },
  })
}

/**
 * @summary Export certificates pdf
 * {@link /v1/certificate/export-certificates-pdf}
 */
export function useExportCertificatesPdf<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<ExportCertificatesPdfMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: ExportCertificatesPdfMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<ExportCertificatesPdfMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? exportCertificatesPdfMutationKey()

  const baseOptions = exportCertificatesPdfMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<ExportCertificatesPdfMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ExportCertificatesPdfMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<ExportCertificatesPdfMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ExportCertificatesPdfMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<ExportCertificatesPdfMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: ExportCertificatesPdfMutationRequest },
    TContext
  >
}
